<div class="modal-container">
  <div class="close-button" (click)="onClose()">
    <img [src]="'assets/icons/gl_close.svg'" alt="Cerrar" />
  </div>
  <div class="row">
    <div class="col-12">
      <img
        class="icon"
        src="/assets/icons/refresh-ccw-clock-1.svg"
        alt="{{ 'sidebar.clockHourTitle' | translate }}"
      />
      <div class="tag">
        <span class="tag-text">{{
          'clockHour.activeAbsences.includeOnPlan' | translate
        }}</span>
      </div>
    </div>
    <div class="col-12">
      <h2 class="title">{{ 'clockHour.activeAbsences.title' | translate }}</h2>
      <p class="description">
        {{ 'clockHour.activeAbsences.description' | translate }}
      </p>
    </div>
    <div class="col-12">
      <button class="roma-button custom-button" (click)="onActivate()">
        {{ 'clockHour.activeAbsences.cta' | translate }}
      </button>
    </div>
  </div>
</div>
